module.exports = __webpack_public_path__ + "static/media/home-button-icon.17743920.svg";